<template>
  <div class="d-content1">
    <!-- 轮播 -->
    <div v-if="$route.meta.banner" class="lunbo">
      <a-carousel dots-class="dot" autoplay>
        <div v-for="(item,i) in banner" :key="i">
          <a :href="item.link"><img :src="'http://'+item.image_file"></a>
        </div>
      </a-carousel>
    </div>
    <!-- 产品下载 -->
    <div class="download main-center">
      <div slot="tabBarExtraContent" class="main-font30 main-bg1 title text-center">{{ $t('title.cpzl') }}</div>
      <div class="tabs">
        <a-tabs tab-position="left" :tab-bar-gutter="1" @change="callback">
          <a-tab-pane v-for="(item,i) in DownloadClass" :key="i" :tab="[$store.state.langStates == 'zh' ? item.category_name:item.category_name_en]">
            <div class="flex">
              <div v-for="(ditem,i) in DownloadList" :key="i" class="info">
                <div class="img text-center">
                  <img :src="'http://'+ [$store.state.langStates == 'zh' ? ditem.image_head_file:ditem.image_head_file_en]">
                </div>
                <div v-if="$store.state.langStates=='zh'" class="margin10 main-font16 main-color">{{ ditem.category }} {{ ditem.series }} {{ ditem.name }}</div>
                <div v-else class="margin10 main-font16 main-color">{{ ditem.category_en }} {{ ditem.series_en }} {{ ditem.name_en }}</div>
                <div class="margin-tb-20">
                  <span>
                  <a-icon type="eye" style="margin: 0 6px 0 20px;" />{{ ditem.review_count }}</span>
                  <span>
                  <a-icon type="download" style="margin: 0 6px 0 20px;" />{{ ditem.sold_count }}</span>
                </div>
                <div v-if="$store.state.langStates=='zh'" class="btn">
                    <a :href="'http://' + ditem.view_file.val" @click.prevent="downloadItem(ditem.uuid,ditem.view_file.val,'3d')">
                      <div>
                        <a-button type="primary" :block="true">3D数模</a-button>
                      </div>
                    </a>
                  <div>
                    <a-dropdown>
                      <a-button type="primary" :block="true">资料下载<a-icon type="down" /> </a-button>
                      <a-menu slot="overlay">
                        <a-menu-item v-for="(item,i) in ditem.document_file" :key="i">
                          <a :href="'http://' + item.path" @click.prevent="downloadItem(ditem.uuid,item.path)">{{ item.name }}</a>
                        </a-menu-item>
                      </a-menu>
                    </a-dropdown>
                  </div>
                </div>
                <div v-else class="btn">
                  <div><a :href="'http://' + ditem.view_file_en.val" @click.prevent="downloadItem(ditem.uuid,ditem.view_file_en.val,'3d')"> <a-button type="primary" :block="true">3D</a-button> </a></div>
                  <div>
                    <a-dropdown>
                      <a-button type="primary" :block="true">Download<a-icon type="down" /> </a-button>
                      <a-menu slot="overlay">
                        <a-menu-item v-for="(item,i) in ditem.document_file_en" :key="i">
                          <a :href="'http://' + item.path" @click.prevent="downloadItem(ditem.uuid,item.path)">{{ item.name }}</a>
                        </a-menu-item>
                      </a-menu>
                    </a-dropdown>
                  </div>
                </div>
              </div>

            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          size="small"
          :total="info.total"
          :show-total="total => `${$t('title.total')} ${info.last_page} ${$t('title.pages')}`"
          :default-page-size="12"
          @change="onChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  export default {
    data() {
      return {
        DownloadClass: '',
        DownloadList: [],
        info: {
          last_page: 0
        },
        name: '',
        name_en: '',
        banner: '',
        document_file: [],
        current:1
      };
    },
    watch: {
      '$route': {
        handler(route) {
          const that = this
          if (route.name === '/download') {
            that.init(that.$store.state.langStates)
          }
        }
      },
      '$store.state.langStates': function(val) {
        this.init(val)
      }
    },
    created() {
      this.init(this.$store.state.langStates)
    },
    methods: {
      callback(key) {
        var lang = this.$store.state.langStates
        if (lang == 'zh') {
          this.name = this.DownloadClass[key].category_name
          this.name_en = ''
          this.getList(lang, 1)
        } else {
          this.name = this.DownloadClass[key].category_name_en
          this.name_en = this.DownloadClass[key].category_name_en
          this.getList(lang, 1)
        }
      },
      init(lang) {
        this.$api.dongjuapi.categories(lang).then(res => {
          this.DownloadClass = res.data.data
          if (this.$store.state.langStates == 'zh') {
            this.name = res.data.data[0].category_name
            this.name_en = ''
          } else {
            this.name = res.data.data[0].category_name_en
            this.name_en = res.data.data[0].category_name_en
          }
          this.getList(lang, 1)
        }).catch(err => {

        })
        // 获取banner
        this.$api.dongjuapi.banner({
          type: 'download'
        }).then(res => {
          if (res.data.code == 200) {
            this.banner = res.data.data
          }
        })
      },
      onChange(current) {
        this.current = current
        this.getList(this.$store.state.langStates, current)
      },
      // 下载列表
      getList(lang, p) {
        this.document_file = []
        this.$api.dongjuapi.downloads({
          lang,
          category_name: this.name,
          category_name_en: this.name_en,
          limit: 12,
          page: p
        }).then(r => {
          this.info = r.data.data
          this.DownloadList = r.data.data.data
        }).catch(err => {
          console.log(err)
        })
      },
      downloadItem(id,url,val) {
        const token = this.$store.state.token
        var d_url = 'http://' + url
        if(val == '3d'){
          if(token == '' || token == null){
            this.$message.error('未登录，请先登录')
            return
          }
        }
        window.open(d_url)
        // axios.get(d_url).then((res) => {
        //   window.open(d_url)
        // }).catch(err => {
        //   this.$message.error('链接已失效，请联系工作人员')
        // })
        this.$api.dongjuapi.count({uuid:id}).then(res=>{
          if(res.data.code == 200){
            this.getList(this.$store.state.langStates, this.current)
          }
        })
      }
    }
  };
</script>
<style lang="less">
  .d-content1 {
    .ant-tabs .ant-tabs-left-content{
      padding-left: 20px;
    }
    .download {
      width: 1380px;
      padding: 80px 0;
      position: relative;

      .title {
        width: 260px;
        height: 100px;
        line-height: 100px;
        border: 1px solid rgba(255, 255, 255, 0);
        position: absolute;
        top: 80px;
      }

      .ant-tabs-left-bar {
        padding-top: 100px;
      }

      .ant-tabs .ant-tabs-left-bar,
      .ant-tabs-left-content {
        border: none;
      }

      .ant-tabs-tab {
        width: 261px;
        background: #fff;
        text-align: left !important;
        padding: 15px 50px !important;
      }

      .ant-tabs-ink-bar {
        width: 0 !important;
      }

      .ant-tabs-nav .ant-tabs-tab-active {
        background: #bbb;
        color: #1E2986;
      }
    }

    .tabs {
      .flex{
        display: flex;
        flex-wrap: wrap;
      }
      .info:not(:nth-child(4n)) {
          margin-right: calc(4% / 3);
      }

      .info {
        width: 24%;
        min-height: 318px;
        background: #fff;
        // margin-right: 19px;
        margin-bottom: 20px;
        padding-bottom: 20px;

        // &:nth-child(4n+5) {
        //   margin-right: 0 !important;
        // }

        .img {
          width: 100%;
          height: 174px;
          border-bottom: 1px solid #E1E1E1;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        div:nth-child(3) {
          color: #999;
        }

        .btn {
          width: 100%;
          height: 30px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: space-around;

          div {
            width: 100px;
          }

          .ant-btn {
            padding: 0;
          }
        }
      }
    }

    #components-pagination-demo-mini {
      text-align: right;
      margin-top: 40px;
      margin-bottom: 40px;

      .ant-pagination-item-active {
        background: #746CAF;
        color: #fff;

        a {
          color: #fff;
        }
      }
    }
  }
</style>
